/**
 * Created by contrapro on 03/04/2018
 */

import { combineEpics } from 'redux-observable';
import login from "./login";
import { onShareOK } from "./wxShare";
import { addUserPoint } from "./point";

export default combineEpics(
    login,
    onShareOK,
    addUserPoint
);



// WEBPACK FOOTER //
// ./src/epics/index.js